export function error(state) {
  return state.error;
}

export function errorMessage(state) {
  return state.errorMessage;
}

export function getNotifications(state) {
  return state.notifications
}

export function getNotificaitonsCount(state) {
  return state.unreadCount
}